export class ParamModel {
    idsucursal: number;
}

export class BannerModel {
    getMimeType: string;
    urlimagen: string;
    idbannersucursal: string;
}
